export default {"src":"/_next/static/media/ranges.9e7b628c.gif","height":600,"width":1000,"blurWidth":0,"blurHeight":0};